"use client";

import { useEffect } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { Quote, Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const testimonials = [
  {
    id: 1,
    name: "Kim Betz",
    role: "Homeowner",
    content:
      "Al is the best!!! He did a beautiful job on my terrazzo, pulling up mexican tile and restoring terrazzo. He just came back to refresh them 10 years later,almost all areas still look really good. Just a few spots and high traffic needed refreshing, and the floors look brand new!!! I've always gotten compliments on that floor since he worked on it. Al and crew are dependable, honest, and do an amazing job. I can highly recommend them. Thank you, Al, for another great outcome!",
  },
  {
    id: 2,
    name: "Keith Anderson",
    role: "Client",
    content:
      "I had a great experience with Allan's floor refinishing service. He was professional, punctual, and easy to work with throughout the process. He explained everything clearly and made sure the job was done right. The floors turned out beautifully,smooth, clean, and like new again. He also kept the workspace tidy and finished on time. I'd definitely recommend Allan to anyone needing floor refinishing.",
  },
  {
    id: 3,
    name: "Brannon Gerling",
    role: "Client",
    content:
      "Al and his team are old-school hard-working professionals. They polished my concrete floors and repaired a concrete sink that I damaged. The quality of the work was excellent, and the price was fair. I'm very appreciative of Al and his team.",
  },
  {
    id: 4,
    name: "John Knof",
    role: "Office Owner",
    content:
      "Wow,that's one way to describe the completed terrazzo floor polish by Tampa Terrazzo (formerly Al Spicer Stone Care / AL Services of Tampa Bay Area). My office carpet was removed to expose the original 1955 terrazzo flooring. Instead of covering it with laminate, Tampa Terrazzo (formerly Al Spicer Stone Care / AL Services of Tampa Bay Area) expertly restored it to its original luster. The results exceeded my expectations.",
  },
  {
    id: 5,
    name: "Roberto Torres",
    role: "Commercial Client",
    content:
      "I am very pleased with the services. I have requested them more than three times for USF clinical buildings, and the clients have been more than happy with the work. Keep up the professionalism.",
  },
  {
    id: 6,
    name: "Jodyhighroller Fonzarelli",
    role: "Homeowner",
    content:
      "Restored and polished my terrazzo floors in my game room. Exceeded my expectations with how smooth and reflective they made them. Prior to renovations we had hardwood floors. They removed them and brought the original terrazzo floor back to life while increasing the value of my home.",
  },
];

const TestimonialSection = () => {
  const [carouselRef, carouselApi] = useEmblaCarousel({
    align: "start",
    loop: true,
  });

  useEffect(() => {
    if (
      !carouselApi ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      return;
    }

    const autoSlide = window.setInterval(() => carouselApi.scrollNext(), 5000);
    return () => window.clearInterval(autoSlide);
  }, [carouselApi]);

  return (
    <section className="relative overflow-hidden bg-[linear-gradient(rgba(24,30,30,0.9),rgba(24,30,30,0.88)),url('/assets/banners/reviews-banner.jpg')] bg-cover bg-center bg-fixed py-12 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-8 text-center md:mb-12">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-amber-300">
            Client testimonials
          </p>
          <h2 className="mt-3 text-3xl font-bold text-white md:text-5xl">
            What Our Clients Say About Us
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-slate-200">
            Real experiences from homeowners who trusted us with their terrazzo
            floors.
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-slate-200">
            4.9/5 BASED ON 37 REVIEWS
          </p>
        </div>

        <div
          ref={carouselRef}
          className="overflow-hidden"
          role="region"
          aria-label="Client testimonials carousel"
        >
          <div className="-ml-3 flex">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="min-w-0 flex-[0_0_100%] pl-3 md:flex-[0_0_50%] xl:flex-[0_0_33.333%]"
              >
                <TestimonialCard testimonial={testimonial} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const TestimonialCard = ({
  testimonial,
}: {
  testimonial: (typeof testimonials)[number];
}) => {
  return (
    <Card className="h-full border-0 bg-white/95 py-0 shadow-xl backdrop-blur-sm">
      <CardContent className="flex h-full flex-col p-6 md:p-8">
        <div className="mb-5 flex items-center justify-between">
          <Quote className="h-8 w-8 text-[#6b4f2d]" aria-hidden="true" />
          <div className="flex" role="img" aria-label="5 out of 5 stars">
            {Array.from({ length: 5 }).map((_, index) => (
              <Star
                key={index}
                className="h-4 w-4 fill-amber-400 text-amber-400"
                aria-hidden="true"
              />
            ))}
          </div>
        </div>
        <p className="flex-1 leading-relaxed text-slate-700 line-clamp-6">
          {testimonial.content}
        </p>
        <div className="mt-6 border-t border-slate-200 pt-5">
          <h3 className="font-bold text-slate-900">{testimonial.name}</h3>
          {/* <p className="text-sm text-slate-600">{testimonial.role} in FL</p> */}
        </div>
      </CardContent>
    </Card>
  );
};

export default TestimonialSection;
